// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2mwN5","label":"Category_label__Vt3-e","content":"Category_content__LuMI9","header":"Category_header__1QNt4","location":"Category_location__3eMGO"};